// extracted by mini-css-extract-plugin
module.exports = {"ant-back-top":"ant-back-top","ant-back-top-rtl":"ant-back-top-rtl","ant-back-top-content":"ant-back-top-content","ant-back-top-icon":"ant-back-top-icon"};